import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.PuzzleSlider;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "PuzzleSlider.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "PuzzleSlider.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "";
    }
}



// WEBPACK FOOTER //
// ./src/games/PuzzleSlider/scenes/IntroductionScene.ts